import { createBrowserRouter } from "react-router";
import { adminRouter } from "@/src/admin/navigations/admin-router";
import { authRouter } from "@/src/auth/navigations/auth-router";
import { RootLayout } from "@/src/common/layouts/root-layout";
import { inviteRouter } from "@/src/invite/navigations/invite-router";
import { marketingRouter } from "@/src/marketing/navigations/marketing-router";
import NotFoundPage from "../pages/not-found-page";

export const rootRouter = createBrowserRouter([
	{
		element: <RootLayout />,
		children: [marketingRouter, authRouter, adminRouter, inviteRouter, { path: "*", element: <NotFoundPage /> }],
	},
]);
